import React, { FunctionComponent } from 'react';
import { Button, Typography } from '@material-ui/core';
import stockCTAStyles from './StockCTAStyles';
import Translation from '../../../../../common/components/translation/Translation';

export interface IStockCTAProps {
  onClick: () => void;
}

const StockCta: FunctionComponent<IStockCTAProps> = ({ onClick }) => {
  const styles = stockCTAStyles();

  return (
    <Button
      className={styles.button}
      color={'primary'}
      variant={'contained'}
      onClick={onClick}
      data-test={'button:sticky:stock-list'}
    >
      <Typography variant={'helpingText'}>
        <Translation id="spc.stock.availableStock" />
      </Typography>
    </Button>
  );
};

export default StockCta;
